import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { getStoredSession, getClaim } from '@/utils/cognito';

const getToken = () => {
  // console.log('Auth store init');
  const session = getStoredSession();
  return session ? session.getIdToken().getJwtToken() : undefined
}

const getGroups = () => {
  try {
    const groups = getClaim('cognito:groups')
    return groups;
  } catch (err) {
    return [];
  }
}

const state = {
  idToken: getToken(),
  status: 'initial',
  session: getStoredSession(),
  cognitoGroups: getGroups(),
  register: {
    status: 'initial'
  },
  codes: {
    status: 'initial',
    data: []
  }
}

const Auth = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Auth;



// WEBPACK FOOTER //
// ./src/store/modules/auth/store.js